import {
    GET_BRANCH_SCHOLASTIC_LIST,
    BRANCH_SCHOLASTIC_LOADING,
    GET_SCHOLASTIC_QUESTION_LIST,
    LOGOUT,
    BRANCH_LIST_AGAINST_SUBJECT_ID_REQUEST,
    BRANCH_LIST_AGAINST_SUBJECT_ID_SUCCESS,
    BRANCH_LIST_AGAINST_SUBJECT_ID_FAILURE,
    SCHOLASTIC_QUESTIONS_LIST_REQUEST,
    SCHOLASTIC_QUESTIONS_LIST_SUCCESS,
    SCHOLASTIC_QUESTIONS_LIST_FAILURE,
} from '../constants';

const initialState = {
    branchScholasticList: [],
    scholasticQuestionList: [],
    showLoadingBranchScholastic: false,
    branchScholasticListAgainstSubjectId: [],
    scholasticQuestionListForSubscriber: [],
    branchCompetitiveList: [],
};

export function BranchScholasticReducer(state = initialState, action) {
    if (action.type === GET_BRANCH_SCHOLASTIC_LIST) {
        return {
            ...state,
            branchScholasticList: action.payload,
            showLoadingBranchScholastic: false,
        };
    }
    
    /* get Scholastic Exam question details into reducer */
    if (action.type === GET_SCHOLASTIC_QUESTION_LIST) {
        return {
            ...state,
            scholasticQuestionList: action.payload,
            showLoadingBranchScholastic: false,
        };
    }
    /* question loader showing when qustion loading */
    if (action.type === BRANCH_SCHOLASTIC_LOADING) {
        return {
            ...state,
            showLoadingBranchScholastic: action.payload,
        };
    }

    if (action.type === BRANCH_LIST_AGAINST_SUBJECT_ID_REQUEST) {
        return {
            ...state,
            showLoadingBranchScholastic: true,
        };
    }

    if (action.type === BRANCH_LIST_AGAINST_SUBJECT_ID_SUCCESS) {
        return {
            ...state,
            branchScholasticListAgainstSubjectId: action.payload,
            showLoadingBranchScholastic: false,
        };
    }

    if (action.type === BRANCH_LIST_AGAINST_SUBJECT_ID_FAILURE) {
        return {
            ...state,
            branchScholasticListAgainstSubjectId: [],
            showLoadingBranchScholastic: false,
        };
    }

    if (action.type === SCHOLASTIC_QUESTIONS_LIST_REQUEST) {
        return {
            ...state,
            showLoadingBranchScholastic: true,
        };
    }

    if (action.type === SCHOLASTIC_QUESTIONS_LIST_SUCCESS) {
        return {
            ...state,
            scholasticQuestionListForSubscriber: action.payload,
            showLoadingBranchScholastic: false,
        };
    }

    if (action.type === SCHOLASTIC_QUESTIONS_LIST_FAILURE) {
        return {
            ...state,
            scholasticQuestionListForSubscriber: [],
            showLoadingBranchScholastic: false,
        };
    }

    if (action.type === LOGOUT) {
        return {
            ...state,
            branchScholasticList: [],
            scholasticQuestionList: [],
            showLoadingBranchScholastic: false,
            branchScholasticListAgainstSubjectId: [],
            scholasticQuestionListForSubscriber: [],
            branchCompetitiveList: [],
        };
    }

    return state;
}

